import Glightbox from './Glightbox';

document.addEventListener('DOMContentLoaded', () => {

  const glightboxElement = document.querySelectorAll('.glightbox');
  if (!glightboxElement.length) {
    return;
  }

  glightboxElement.forEach((element) => {
    const glightboxE = new Glightbox(element);
    glightboxE.mount(element);
  })
});
